<script>
import {defineComponent} from 'vue'

export default defineComponent({
    name: "IconDesigner"
})
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 192">
        <g fill="none" stroke="#000000" stroke-width="12">
            <path stroke-linecap="round" d="M154 56a58 58 0 0 1-29.3 50.4 58 58 0 0 1-58.29-.513"/>
            <path d="M122 56a26 26 0 0 1-26 26 26 26 0 0 1-26-26 26 26 0 0 1 26-26 26 26 0 0 1 26 26z"/>
            <path stroke-linecap="round" d="m170 160-58-80m-90 80 58-80"/>
        </g>
    </svg>
</template>

<style scoped lang="scss">

</style>
